/**
 * created by hezq on 2019-09-09
 *
 * description： 配置文件
 *
 */

const config = {
	// 项目名称
	PROJECT_NAME: 'kjxy',
	// 域名前缀标识
	PLAT: 'Market',
	// 系统id
	SUB_SYSTEM: 'S00000',
	// 平台编码，由基础服务配置产生
	SSID: 'M11220',
	// 框架协议地址
	MS_XY_PATH: '//msapi.norincogroup-ebuy.com/xyweb',
	// FIXME:以下参数可能不需要用到，先暂存
	// BS基础平台
	BASE_PATH: '//bsapi.norincogroup-ebuy.com/baseInvoker',
	// sso地址
	MS_SSO_PATH: '//msapi.norincogroup-ebuy.com/ssobsweb',
	// 权限服务地址
	MS_AUTH_PATH: '//msapi.norincogroup-ebuy.com/authweb',
	// 审批服务地址
	MS_ATT_PATH: '//msapi.norincogroup-ebuy.com/attweb',
	// 文件服务地址
	MS_FILE_PATH: '//resource.norincogroup-ebuy.com',
	// 资源服务地址
	MS_DOC_PATH: '//resource.norincogroup-ebuy.com',
	// 发票服务地址
	MS_MB_PATH: '//msapi.norincogroup-ebuy.com/mbcweb',
	// 会员服务地址
	API_MB: '//msapi.norincogroup-ebuy.com/menberweb',
	// 地址服务地址
	MS_ADD_PATH: '//msapi.norincogroup-ebuy.com/bsmweb',
	// 2.0资源服务地址
	DOC_PATH: '//file.norincogroup-ebuy.com',
	// 基础前台
	BS_PATH: '//bs.norincogroup-ebuy.com',
	// 采购前台
	TD_PATH: '//www.norincogroup-ebuy.com',
	// 询价地址
	INQUIRY_PATH: '//td.norincogroup-ebuy.com',
	// 询价地址
	INQUIRY_NEW_PATH: '//bidtd.norincogroup-ebuy.com/inquirynweb',
	// 招投标地址
	BID_PATH: '//bid.norincogroup-ebuy.com',
	// 竞谈地址
	JT_PATH: '//jt.norincogroup-ebuy.com',
	// domain配置
	DOMAIN: '.norincogroup-ebuy.com',
	// 服务端接口报错默认提示
	MSG_SERVER_ERROR: '服务内部错误',
	// 未登录或登录失效默认提示
	MSG_NO_LOGIN: '未登录或登录失效，请重新登录',
	// 请求接口无权限默认提示
	MSG_NO_AUTH: '请求无权限'
}

module.exports = config



// WEBPACK FOOTER //
// ./src/libs/config.js